import React from 'react';
import { Modal } from 'antd';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';
import SearchRetrieve from '../common/SearchRetrieve.new.js';
import './css/list.less';

class TransferPro extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            loading: false,
            role: '',
            user: {},
            saveParams: {},
        };
    }

    show = (user, role) => {
        this.setState({
            user,
            role,
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            saveParams: {},
        });
    }

    handleSubmit = () => {
        const { investigationId } = this.props;
        const { user = {}, saveParams, role } = this.state;
        const { userId } = saveParams;
        const handoverUserId = user.value;

        if (!userId) {
            Modal.error({ title: "请选择交接人" })
            return;
        }
        this.setState({ loading: true });

        const options = {
            url: `${API_URL.investigation.handOverPmFte}`,
            data: {
                investigationId,
                handoverUserId,
                userId,
                roleCode: role,
            },
            dataType: 'json',
            doneResult: data => {
                this.setState({ loading: false });
                this.props.loadData();
                this.hide();
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    handleChange = (option, key) => {
        const { saveParams } = this.state;
        const { text, value } = option;
        saveParams.userId = value;
        saveParams.userName = text;
        this.setState({ saveParams });
    }

    render() {
        const { investigationName, investigationCode } = this.props;
        const { visible, loading, user, role, saveParams } = this.state;
        const { userName } = saveParams;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const roleName = (role === "PM" && "项目经理") || (role === "PA" && "项目管理员") || (role === "BA" && "BA");
        return (
            <Modal
                title={`${roleName}交接`}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                loading={loading}
                maskClosable={false}
                width="400px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <ul className="modal-list">
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">项目简称:</div>
                            <div className="item-right">
                                {investigationName}
                            </div>
                        </li>
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">项目编号:</div>
                            <div className="item-right">
                                {investigationCode}
                            </div>
                        </li>
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">{roleName}:</div>
                            <div className="item-right">
                                {user.text}
                            </div>
                        </li>
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">{asterisk}工作交接给:</div>
                            <div className="item-right">
                                {
                                    <SearchRetrieve
                                        keyword='keyword'
                                        style={{ width: 160, marginBottom: 10 }}
                                        value={userName}
                                        params={{ limit: 20, dimissionStatus: 'WORKING' }}
                                        placeholder="输入姓名/工号检索"
                                        url={API_URL.team.userlist}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={option => this.handleChange(option, 'userId')}
                                    />
                                }
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export default TransferPro;


// WEBPACK FOOTER //
// ./src/components/investigation/TransferPro.js